(function () {
  function hashString(value) {
    var hash = 0;
    var i;
    for (i = 0; i < value.length; i += 1) {
      hash = ((hash << 5) - hash) + value.charCodeAt(i);
      hash |= 0;
    }
    return Math.abs(hash);
  }

  function pickReviewIndex(seed, count) {
    var base = hashString(seed);
    var randomOffset = Math.floor(Math.random() * count);
    return (base + randomOffset) % count;
  }

  function renderReview(quoteEl, review) {
    if (!quoteEl || !review) return;
    quoteEl.innerHTML = '<p>"' + review.quote.replace(/"/g, '&quot;') + '"</p><footer>— ' + review.author + '</footer>';
  }

  function initPdpGoogleReview(root) {
    var reviews = window.KUNJAREE_GOOGLE_REVIEWS;
    if (!reviews || !reviews.length) return;

    var quoteEl = root.querySelector('.kunjaree-pdp__sample-review-quote');
    if (!quoteEl) return;

    var handle = root.getAttribute('data-product-handle') || '';
    var productId = root.getAttribute('data-product-id') || '';
    var seed = handle + '|' + productId;
    var index = pickReviewIndex(seed, reviews.length);

    renderReview(quoteEl, reviews[index]);
  }

  function initAll() {
    document.querySelectorAll('[data-kunjaree-google-review]').forEach(initPdpGoogleReview);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
